import Croppie from '../../../../node_modules/croppie/croppie.js'
require('../../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.js')
require('jquery-confirm')

const SizeExeeds = () => {
  $.confirm({
    animation        : 'scale',
    backgroundDismiss: true,
    closeAnimation   : 'scale',
    smoothContent    : false,
    theme            : 'modern',
    typeAnimated     : false,
    useBootstrap     : false,

    content: `<p>La imagen debe pesar menos de 6MB</p>`,
    title  : `Hay un problema`,
    type   : 'red',
    animation        : 'scale',
    backgroundDismiss: true,
    closeAnimation   : 'scale',
    smoothContent    : false,
    theme            : 'modern',
    typeAnimated     : false,
    useBootstrap     : false,

    buttons: {
      close: {
        btnClass: 'btn--alert-close',
        text: '<span class="x:fs-14 x:middle">Cerrar</span> <span class="x:fs-20 x:middle">X</span>'
      }
    }
  })

  return
}
const OpenFancyBox = () => {
  $.fancybox.open({
    src  : '#hidden-crop-image',
    type : 'inline',
    opts : {
      touch: false,
      afterShow: (instance, current) => {
        // ...
      },
      afterClose: () => {
        // ...
      }
    }
  })
}
const CloseFancyBox = () => {
  $.fancybox.close({
    src  : '#hidden-crop-image',
  })
}
const SetCroppieImage = ($croppie, image) => {
  image = image.srcElement.files[0]

  const fileReader = new FileReader()

  fileReader.onloadend = () => {
    $croppie.bind({
      url: fileReader.result,
    })

    OpenFancyBox()
  }

  fileReader.readAsDataURL(image)
}
const SavePicture = ($croppie, $profilePic) => {
  const $form = $profilePic.closest('form')
  const $result = $form.querySelector('input[name="profile_pic"]')

  $croppie.result('base64').then((base64) => {
    $result.value = base64
    $form.submit()
  })
}
const InitCroppie = ($profilePic, $profilePicLabel) => {
  let   $croppie = document.querySelector('.crop-image')
  // const $cancel = document.querySelector('[close-profile-pic]')
  const $save = document.querySelector('[save-profile-pic]')

  if (!$croppie) return

  $croppie = new Croppie($croppie, {
    viewport: {
      height: 280,
      width: 280,
      type: 'circle'
    },
    boundary: {
      height: 300,
      width: 300,
    },
    enforceBoundary: false,
    enableOrientation: true,
  })

  Listeners($croppie, $profilePic, $profilePicLabel, $save)
}
const Listeners = ($croppie, $profilePic, $profilePicLabel, $save) => {
  $profilePicLabel.addEventListener('click', () => {
    $profilePic.value = null
  })

  $profilePic.addEventListener('change', e => {
    if (!e.currentTarget.value) return
    if(e.srcElement.files[0].size >= 6000000) SizeExeeds()

    SetCroppieImage($croppie, e)
  })

  /* $cancel.addEventListener('click', e => {
    e.preventDefault()
    ProfilePicUrl = null

    CloseFancyBox()
  }) */

  $save.addEventListener('click', e => {
    e.preventDefault()
    SavePicture($croppie, $profilePic)
  })
}

const CropImage = () => {
  const $profilePicLabel = document.querySelector('[for="profile_pic_file"]')
  const $profilePic = document.querySelector('input[name="profile_pic_file"]')

  if (!$profilePic) return

  InitCroppie($profilePic, $profilePicLabel)
}

export default CropImage
